import { createContext } from 'react';
import { DEFAULT_STORE_GROUP_CONTEXT } from './constants/defaultContext';

const StoreGroupContext = createContext(DEFAULT_STORE_GROUP_CONTEXT);

export default StoreGroupContext;
